import { useSecurityDialog } from "../SecurityDialogProvider"
import {
  SecurityDialog,
  SecurityDialogContainer,
  SecurityDialogTitle,
  SecurityLabel,
  SecurityPrimaryButton,
  WrongAccount,
} from "../common"
import { useSendEmail } from "../common/useSendEmail"

export type ActivatePrivateAccessDialogProps = {
  open: boolean
  goHome: () => void
}

export const ActivatePrivateAccessDialog = ({
  open,
  goHome,
}: ActivatePrivateAccessDialogProps) => {
  const security = useSecurityDialog()
  const { sendEmail, loading } = useSendEmail()
  const handleActivatePrivateAccess = () => {
    sendEmail().then(() => security.emailSentDialog({ goHome }))
  }
  return (
    <SecurityDialog open={open}>
      <SecurityDialogTitle />
      <SecurityDialogContainer>
        <SecurityLabel>
          Vous n'avez pas encore créé de code sécurisé pour accéder à votre Espace
          Privé.
        </SecurityLabel>
        <SecurityLabel>
          Veuillez activer votre accès privé avec le bouton ci-dessous :
        </SecurityLabel>
        <SecurityPrimaryButton
          onClick={handleActivatePrivateAccess}
          disabled={loading}
        >
          Activer mon accès privé
        </SecurityPrimaryButton>
      </SecurityDialogContainer>
      <WrongAccount onClickGoHome={goHome} />
    </SecurityDialog>
  )
}
